export default __webpack_public_path__ + "static/media/Tire.919afc9e.svg";